import { ref, push, set, get, update, remove } from 'firebase/database';
import { db } from '../firebase';

// Blog operations
export const createBlog = async (blogData) => {
  const blogsRef = ref(db, 'blogs');
  const newBlogRef = push(blogsRef);
  await set(newBlogRef, {
    ...blogData,
    id: newBlogRef.key,
    createdAt: Date.now(),
    updatedAt: Date.now()
  });
  return newBlogRef.key;
};

export const getBlogs = async () => {
  const blogsRef = ref(db, 'blogs');
  const snapshot = await get(blogsRef);
  if (snapshot.exists()) {
    const blogs = [];
    snapshot.forEach((childSnapshot) => {
      blogs.push({
        id: childSnapshot.key,
        ...childSnapshot.val()
      });
    });
    return blogs;
  }
  return [];
};

export const getBlogById = async (blogId) => {
  const blogRef = ref(db, `blogs/${blogId}`);
  const snapshot = await get(blogRef);
  if (snapshot.exists()) {
    return {
      id: snapshot.key,
      ...snapshot.val()
    };
  }
  return null;
};

export const updateBlog = async (blogId, updates) => {
  const blogRef = ref(db, `blogs/${blogId}`);
  await update(blogRef, {
    ...updates,
    updatedAt: Date.now()
  });
};

export const deleteBlog = async (blogId) => {
  const blogRef = ref(db, `blogs/${blogId}`);
  await remove(blogRef);
};

// Contact form operations
export const submitContactForm = async (contactData) => {
  const contactsRef = ref(db, 'contact_submissions');
  const newContactRef = push(contactsRef);
  await set(newContactRef, {
    ...contactData,
    id: newContactRef.key,
    timestamp: Date.now(),
    status: 'new'
  });
  return newContactRef.key;
};

export const getContactSubmissions = async () => {
  const contactsRef = ref(db, 'contact_submissions');
  const snapshot = await get(contactsRef);
  if (snapshot.exists()) {
    const contacts = [];
    snapshot.forEach((childSnapshot) => {
      contacts.push({
        id: childSnapshot.key,
        ...childSnapshot.val()
      });
    });
    return contacts;
  }
  return [];
};

// Analytics operations
export const logPageView = async (pageData) => {
  const analyticsRef = ref(db, 'analytics/page_views');
  const newViewRef = push(analyticsRef);
  await set(newViewRef, {
    ...pageData,
    timestamp: Date.now()
  });
};

export const logEvent = async (eventData) => {
  const eventsRef = ref(db, 'analytics/events');
  const newEventRef = push(eventsRef);
  await set(newEventRef, {
    ...eventData,
    timestamp: Date.now()
  });
};

// User operations
export const createUserProfile = async (userId, userData) => {
  const userRef = ref(db, `users/${userId}`);
  await set(userRef, {
    ...userData,
    createdAt: Date.now(),
    updatedAt: Date.now()
  });
};

export const getUserProfile = async (userId) => {
  const userRef = ref(db, `users/${userId}`);
  const snapshot = await get(userRef);
  if (snapshot.exists()) {
    return {
      id: snapshot.key,
      ...snapshot.val()
    };
  }
  return null;
};

export const updateUserProfile = async (userId, updates) => {
  const userRef = ref(db, `users/${userId}`);
  await update(userRef, {
    ...updates,
    updatedAt: Date.now()
  });
};
